// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Soft_wrapper__TAqjs","btn":"Soft_btn__rfQ4d","container":"Soft_container__o6mTI"};